import { useState } from 'react';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export enum DashboardMode {
    Locations,
    Devices,
    Sensors,
}

//-------------------------------------------------------------------------------------------------
function modeLabel(mode: DashboardMode): string {
    //prettier-ignore
    switch (mode) {
        case DashboardMode.Locations : return 'Локации';
        case DashboardMode.Devices   : return 'Устройства';
        case DashboardMode.Sensors   : return 'Датчики';
        default                      : return 'Undefined';
    }
}

//=================================================================================================
export interface ModeSwitchProps {
    state: DashboardMode;
    setState: (mode: DashboardMode) => void;
    onAll?: () => void;
}

export default function ModeSwitch({ state, setState, onAll }: ModeSwitchProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleSelect = (mode: DashboardMode) => {
        setState(mode);
        setAnchorEl(null);
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button
                onClick={(e) => setAnchorEl(e.currentTarget)}
                endIcon={<ExpandMoreIcon />}
                sx={{
                    textTransform: 'none',
                    color: 'text.primary',
                    fontWeight: 600,
                    px: 1,
                }}
            >
                {modeLabel(state)}
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                slotProps={{
                    paper: {
                        sx: { minWidth: 160 },
                    },
                }}
            >
                {(Object.values(DashboardMode).filter((v) => typeof v === 'number') as DashboardMode[]).map((mode) => (
                    <MenuItem
                        key={mode}
                        selected={mode === state}
                        onClick={() => handleSelect(mode)}
                        sx={{
                            '&.Mui-selected': { color: 'primary.main', fontWeight: 600 },
                        }}
                    >
                        <Typography variant="body2">{modeLabel(mode)}</Typography>
                    </MenuItem>
                ))}
            </Menu>

            <Button
                size="small"
                variant="text"
                onClick={onAll}
                sx={{ textTransform: 'none', color: 'text.secondary', ml: 'auto' }}
            >
                All
            </Button>
        </Box>
    );
}
